import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'unstated'

import './global-styles'
import SceneManager from './component/_scenes/SceneManager'

ReactDOM.render(
  <Provider>
    <SceneManager />
  </Provider>,
  document.getElementById('root'),
)



// WEBPACK FOOTER //
// ./src/index.js